(() => {
  class StoreHours extends HTMLElement {
    connectedCallback() {
      const hours = this.querySelector('[data-hours]');
      if (!hours) return;

      try {
        const weekday = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Chicago',
          weekday: 'short',
        }).format(new Date());
        const key = weekday === 'Sat' ? 'saturday' : weekday === 'Sun' ? 'sunday' : 'weekdays';
        if (this.dataset[key]) hours.textContent = this.dataset[key];
      } catch {
        // Keep the server-rendered weekday hours if time zone formatting is unavailable.
      }
    }
  }

  if (!customElements.get('mj-store-hours')) {
    customElements.define('mj-store-hours', StoreHours);
  }
})();
